import Toast from 'react-native-toast-message';
import { bridge } from '../../utils';
import { Flex, Typography } from '@banhala/ui-kit';
import { Dimensions } from 'react-native';
import { moveToLikeFolders } from '../../utils/navigator/useCommonNavigator/moveToLikeFolders';

const pagePadding = 12 * 2;
const toastPadding = 14 * 2;
const restTextWidth = 160;
export const toast = ({
  folderName,
  folderSno,
  screen,
  bottomOffset,
}: {
  screen: string;
  folderName: string;
  folderSno: number;
  bottomOffset?: number;
}) => {
  const text = folderName;
  const folderNameMaxWidth =
    Dimensions.get('window').width - pagePadding - toastPadding - restTextWidth;
  Toast.show({
    type: 'success',
    bottomOffset,
    props: {
      customText: (
        <Flex.Row
          padding={{
            vertical: 12,
          }}
          width={'100%'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Flex.Row>
            <Typography
              type="subtitle2"
              color={'content_always_white'}
              numberOfLines={1}
              ellipsizeMode="tail"
              maxWidth={folderNameMaxWidth}
            >
              {text}
            </Typography>
            <Typography type="body2" color="content_always_white">
              에 상품을 찜했어요
            </Typography>
          </Flex.Row>
          <Flex.Column
            onPress={() => {
              bridge.logAnalyticsEvent({
                name: 'CLICK_FOLDER',
                analytics: {
                  SCREEN: screen,
                  FOLDER_SNO: folderSno,
                  LANDING_FROM: 'TOAST',
                },
              });
              moveToLikeFolders({ folderSno });
            }}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          >
            <Typography color={'content_blue_primary'}>보러가기</Typography>
          </Flex.Column>
        </Flex.Row>
      ),
    },
    position: 'bottom',
  });
};
